var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { AppearanceSettings } from 'packages/job_lists/AppearanceSettings';
import { ColorConfiguration } from 'packages/job_lists/ColorConfiguration';
var tailwind = require('../../../../tailwind.config');
var CompanyStyles = /** @class */ (function (_super) {
    __extends(CompanyStyles, _super);
    function CompanyStyles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultAppearance = new AppearanceSettings();
        return _this;
    }
    CompanyStyles.prototype.created = function () {
        this.defaultAppearance.colors = new ColorConfiguration();
        this.defaultAppearance.colors.headingsAndTitles = tailwind.theme.colors.charcoal;
        this.defaultAppearance.colors.logoBackground = tailwind.theme.colors.charcoal;
        this.defaultAppearance.colors.footer = tailwind.theme.colors.white;
        this.defaultAppearance.colors.linksAndButtons = tailwind.theme.colors.purple;
        this.defaultAppearance.colors.footerBackground = tailwind.theme.colors.charcoal;
        this.setAppearance(this.defaultAppearance);
    };
    CompanyStyles.prototype.mounted = function () {
        document.head.appendChild(this.$el);
    };
    var _a;
    __decorate([
        State,
        __metadata("design:type", typeof (_a = typeof AppearanceSettings !== "undefined" && AppearanceSettings) === "function" ? _a : Object)
    ], CompanyStyles.prototype, "appearance", void 0);
    __decorate([
        Mutation,
        __metadata("design:type", Object)
    ], CompanyStyles.prototype, "setAppearance", void 0);
    CompanyStyles = __decorate([
        Component
    ], CompanyStyles);
    return CompanyStyles;
}(Vue));
export default CompanyStyles;
